export default {
  APPEND_CHANGELOG_PAGE(state, { items, lastEvaluatedKey, reset }) {
    if (reset) {
      state.entries = [];
    }
    const knownIds = new Set(state.entries.map((entry) => entry._id));
    const newEntries = items.filter((entry) => !knownIds.has(entry._id));
    state.entries = state.entries.concat(newEntries);
    state.lastEvaluatedKey = lastEvaluatedKey || null;
  },

  RESET_CHANGELOG(state) {
    state.entries = [];
    state.lastEvaluatedKey = null;
  },
};
